"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_select_1 = __importDefault(require("react-select"));
const styled_components_1 = __importDefault(require("styled-components"));
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const apiUtils_1 = require("../../../util/apiUtils");
const theme_1 = require("../../../theme");
const common_styled_components_1 = require("../../common-styled-components");
const BookingTable_1 = require("../common/tables/BookingTable");
const TransactionTable_1 = require("../common/tables/TransactionTable");
const PoolShipCard_1 = __importDefault(require("./PoolShipCard"));
// ─── Styled components ──────────────────────────────────────────────────────
const ShipsGrid = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: ${theme_1.theme.spacing(3)};
  width: 100%;
`;
const SelectWrapper = styled_components_1.default.div `
  width: 280px;
`;
const PoolSection = ({ selectedYear }) => {
    const [selectedPoolId, setSelectedPoolId] = (0, react_1.useState)(null);
    const [overview, _setOverviewUrl, setOverviewBody] = (0, useFetch_1.default)("admin/overview.json", undefined, true);
    const [poolDetail, _setPoolUrl, setPoolBody, _refreshPool] = (0, useFetch_1.default)("admin/pools.json", undefined, true);
    const [bookings, _setBookingsUrl, setBookingsBody, refreshBookings] = (0, useFetch_1.default)("admin/pool_bookings.json", undefined, true);
    const [transactions, _setTransUrl, setTransBody, refreshTransactions] = (0, useFetch_1.default)("admin/transactions.json", undefined, true);
    (0, react_1.useEffect)(() => {
        if (selectedPoolId === null)
            return;
        const body = JSON.stringify({
            pool_id: selectedPoolId,
            year: selectedYear,
        });
        setPoolBody(body);
        setBookingsBody(body);
        setTransBody(body);
        setOverviewBody(JSON.stringify({ pool_year: selectedYear }));
    }, [
        selectedPoolId,
        selectedYear,
        setPoolBody,
        setBookingsBody,
        setTransBody,
        setOverviewBody,
    ]);
    const poolOptions = (0, react_1.useMemo)(() => {
        if (overview.status !== apiUtils_1.LoaderStatus.Success)
            return [];
        return overview.data.pools.map((p) => ({ value: p.id, label: p.name }));
    }, [overview]);
    (0, react_1.useEffect)(() => {
        if (poolOptions.length > 0 && selectedPoolId === null) {
            setSelectedPoolId(poolOptions[0].value);
        }
    }, [poolOptions, selectedPoolId]);
    const selectedOption = poolOptions.find((o) => o.value === selectedPoolId) ?? null;
    const poolData = poolDetail.status === apiUtils_1.LoaderStatus.Success && poolDetail.data.length > 0
        ? poolDetail.data[0]
        : null;
    const providerShips = (0, react_1.useMemo)(() => {
        if (!poolData)
            return [];
        return poolData.ships.filter((ship) => (ship.intensity?.adjusted_emission_balance_ton ?? 0) > 0);
    }, [poolData]);
    const bookingData = bookings.status === apiUtils_1.LoaderStatus.Success ? bookings.data : null;
    const transactionData = transactions.status === apiUtils_1.LoaderStatus.Success ? transactions.data : null;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Select pool" }), (0, jsx_runtime_1.jsx)(SelectWrapper, { children: (0, jsx_runtime_1.jsx)(react_select_1.default, { options: poolOptions, value: selectedOption, onChange: (opt) => setSelectedPoolId(opt?.value ?? null), placeholder: "Select a pool\u2026", isClearable: false }) })] }), selectedPoolId !== null && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [poolDetail.status === apiUtils_1.LoaderStatus.Loading && (0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: "Loading pool\u2026" }), poolData && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: { margin: `${theme_1.theme.spacing(4)} 0 ${theme_1.theme.spacing(2)}` }, children: "Pool provider ships" }), providerShips.length === 0 ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: "No ships with positive adjusted emission balance." })) : ((0, jsx_runtime_1.jsx)(ShipsGrid, { children: providerShips.map((ship) => ((0, jsx_runtime_1.jsx)(PoolShipCard_1.default, { ship: ship, selectedYear: selectedYear }, ship.id))) })), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, style: { marginTop: theme_1.theme.spacing(4) }, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Bookings" }), (0, jsx_runtime_1.jsx)(BookingTable_1.BookingTable, { bookings: bookingData ?? [], pool: poolData, refresh: refreshBookings, isInAdminTools: true })] }) }), transactionData !== null && ((0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Compliance transactions" }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { transactions: transactionData, complianceYear: selectedYear, poolId: poolData.id, refresh: refreshTransactions, isInAdminTools: true })] }) }))] }))] }))] }));
};
exports.default = PoolSection;
